var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 405.333 405.333",
    style: {
      enableBackground: "new 0 0 405.333 405.333"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.667,0C117.333,0,32,10.667,32,85.333V288c0,41.173,33.493,74.667,74.667,74.667l-32,32v10.667h47.573l42.667-42.667    h80.427L288,405.333h42.667v-10.667l-32-32c41.173,0,74.667-33.493,74.667-74.667V85.333C373.333,10.667,296.96,0,202.667,0z     M106.667,320c-17.707,0-32-14.293-32-32s14.293-32,32-32s32,14.293,32,32S124.373,320,106.667,320z M181.333,170.667H74.667    V85.333h106.667V170.667z M298.667,320c-17.707,0-32-14.293-32-32s14.293-32,32-32s32,14.293,32,32S316.373,320,298.667,320z     M330.667,170.667H224V85.333h106.667V170.667z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ED3D3E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.ed0c1d8c7beb03786e49d4f16f70d22c.svg";
export { ForwardRef as ReactComponent };